import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  TextField
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import { ReactComponent as DeleteIcon } from "../../../Icons/DeleteTable.svg";
import { ReactComponent as EditIcon } from "../../../Icons/EditIcon.svg";
import AlertModal from "../../../CommonComponents/AlertModal";
import LinearProgress from '@mui/material/LinearProgress';
import CachedIcon from '@mui/icons-material/Cached';
import VisibilityIcon from '@mui/icons-material/Visibility';
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";

export default function BookedServicesMain() {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false)

  const [filters, setFilters] = useState({
    name: '',
    service_name: '',
    order_complete_status: ''
  });

  let deleteData = {
    label: "Confirm Delete Service",
    descriptionOne: "Please confirm that you wish to delete the Service.",
    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#912018",
      text: "Confirm",
    },
  };

  const [hostelData, setHostelData] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [serviceList, setServiceList] = useState([])

  const getAllHostel = async () => {
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-booked-service?page=${
          page + 1
        }&limit=${rowsPerPage}`
      );
      console.log(response);
      setHostelData(response?.data?.data || []);
      setTotalItems(response.data.pagination.totalItems || 0)
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  const fetchServiceDatas = async () => {
    try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-all-common-services`)
      
      console.log(response)
      
      if(response.status === 200){
        const fetchedServices = response?.data?.data || [];
        setServiceList(fetchedServices)
        
      }
    } catch (error) {
      console.log(error)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
}

useEffect(() => {
  fetchServiceDatas()
}, [])

  const handleClose = () => {
    setDeleteModal(null);
    setDeleteId(null);
  };

  const deleteHostel = async () => {
    try {
      await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}delete-booked-service/${deleteId}`
      );
      getAllHostel();
      setDeleteModal(null);
      setDeleteId(null);
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   getAllHostel();
  // }, [page, rowsPerPage]);


  const handleSeeMore = (description) => {
    setSelectedDescription(description);
  };


  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page change
  };

  useEffect(() => {
    const fetchData = async () => {
      // if no filter, grab full list
      if (
        !filters.name &&
        !filters.service_name &&
        !filters.order_complete_status
      ) {
        getAllHostel();
        return;
      }
  
      // build query‑string
      const query = new URLSearchParams({
        ...filters,
        page: String(page + 1),
        limit: String(rowsPerPage),
      }).toString();
  
      try {
        const { data } = await axiosInstance.get(
          `/get-student-booked-service-filter?${query}`
        );
  
        setHostelData(data?.data || []);
        setTotalItems(data?.pagination?.totalItems || 0);
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchData();
    // include paging deps if table paging changes should refetch
  }, [filters, page, rowsPerPage]);
  

  


  return (
    <>
      {deleteModal && (
        <AlertModal
          modalDatas={deleteData}
          confirmFunction={deleteHostel}
          closeFunction={handleClose}
        />
      )}
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h7_1">Booked Services</Typography>
        
        <Box sx={{display : 'flex', gap : 3, alignItems : 'center'}}>
        <Typography variant="h7_1" sx={{cursor : 'pointer'}} title='Reload' onClick={() => getAllHostel()}><CachedIcon /></Typography>
        {/* <Button
          onClick={() => navigate("/Admin/add-common-service")}
          variant="contained"
        >
          Add
        </Button> */}
        </Box>
       
      </Stack>
      
      <TableContainer sx={{
        mt : 3.5,
          borderRadius: "5px",
          border: "1px solid #e5e5e5",
          boxShadow: "0px 0px 30px 20px #f4f4f4",
        }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Student Name
                </Typography>
                <Box sx={{mt : 1, display : 'flex', justifyContent : 'center'}}>
                <input 
              placeholder="Enter student name"
          style={{width : '80%', height : '30px'}}
          onChange={(e) => setFilters({name : e.target.value})}
        />
        </Box>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                  Service Asked
                </Typography>
                <Box sx={{mt : 1, display : 'flex', justifyContent : 'center'}}>
                <select 
              
          style={{width : '80%', height : '30px'}}
          onChange={(e) => setFilters({service_name : e.target.value})}
        >
          <option value="">Select service name</option>
          {serviceList.map((serv) => (
            <option value={serv?.title?.en}>{serv?.title?.en}</option>
          ))}
        </select>
        </Box>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                 Order Complete Status
                </Typography>
                <Box sx={{mt : 1, display : 'flex', justifyContent : 'center'}}>
                <select 
              
          style={{width : '80%', height : '30px'}}
          onChange={(e) => setFilters({order_complete_status : e.target.value})}
        >
          <option value="">Select order complete status</option>
          <option value='true'>Completed</option>
          <option value='false'>Pending</option>
        </select>
        </Box>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date and Time
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Actions
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}

            {hostelData.length == 0 ? (<>
              <TableRow>
              <TableCell colSpan={5} sx={{borderBottom: "0.5px solid #dcdddc", py: 2.7}}>
            {!loading && (
            <Typography>No data found</Typography>
            )}
            </TableCell>
            </TableRow>
            </>) : (
            hostelData.map((item, index) => (
              <TableRow
                key={item.name}
                sx={{border: "0px",
                backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white"}}
              >
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                <Typography variant="h9_4" color="#333333">
                    {item?.form_data?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.service_name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc",  }}>
                    {item?.order_complete_status === true ? (
                      <>
                      <Box sx={{display : 'flex', justifyContent : 'center',alignItems : 'center', gap : 2}}>
                        <span style={{width : '20px', height : '20px', borderRadius : '100%', backgroundColor : '#4caf50'}}></span>
                        <Typography>Completed</Typography>
                      </Box>
                      </>
                    ) : (
                      <Box sx={{display : 'flex', justifyContent : 'center',alignItems : 'center', gap : 2}}>
                        <span style={{width : '20px', justifyContent : 'center',height : '20px', borderRadius : '100%', backgroundColor : '#ffac33'}}></span>
                        <Typography >Pending</Typography>
                      </Box>
                    )}
  
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <Typography variant="h9_4" color="#333333">
                    {dayjs(item?.createdAt).format("DD/MM/YYYY hh:mm A") || "-"}
                  </Typography>
                </TableCell>

                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <IconButton
                    onClick={() => navigate(`/Admin/view-booked-services/${item._id}`)}
                    sx={{ marginRight: "10px" }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  {/* <IconButton
                    onClick={() => {
                      setDeleteId(item._id);
                      setDeleteModal(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItems} 
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />

      </TableContainer>
      <Dialog
        open={!!selectedDescription}
        onClose={() => setSelectedDescription("")}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Full Description</DialogTitle>
        <Divider></Divider>
        <DialogContent>
          <Typography variant="body1">{parse(selectedDescription)}</Typography>
        </DialogContent>
        <Divider></Divider>
        <DialogActions>
          <Button
            onClick={() => setSelectedDescription("")}
            color="primary"
            variant="contained"
            sx={{ margin: "10px", padding: "10px 20px" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
